import React from 'react';
import { Link, Route } from 'react-router-dom';
import AccessControl from '../../services/access-control';

const NavbarLink = ({ to, path, children, exact, active, disabled, additionalClassName, onClick}) => (
  <Route exact={exact} path={path || to} children={({ match }) => {
    let className = '';

   if (active !== undefined) {
      className = active && 'active';
    } else {
      className = match && 'active';
    }

    if (disabled) {
      className = `${className ? className : ''} disabled`;
    }

    if (additionalClassName) {
      className = `${className ? className : ''} ${additionalClassName}`;
    }

    return (
      <li role="presentation" className={className} onClick={onClick}>
        <Link to={to} onClick={event => disabled && event.preventDefault()}>{children}</Link>
      </li>
    )}
  } />
);

export default ({ rule, target, ...rest }) => {
  if (rule) {
    const [permission, accessScope] = rule.split(':').reverse();

    return AccessControl.can(permission, accessScope, target)
      ? <NavbarLink {...rest} /> : null;
  }

  return <NavbarLink {...rest} />;
};



// WEBPACK FOOTER //
// ./src/components/common/navbar-link.js